import { Injectable } from '@angular/core';

import { ConfigService } from '@common/services/config/config.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureSupportService {
  constructor(private configService: ConfigService) {}

  public isFeaturesEnabled(features: string | string[]): boolean {
    const featureList = this.getLoweredFeatureList(features);
    return featureList.every((featureType) => this.configService.featuresByType.has(featureType));
  }

  private getLoweredFeatureList(features: string | string[]): string[] {
    if (Array.isArray(features)) {
      return features.map((feature) => feature.toLowerCase());
    } else {
      return [features.toLowerCase()];
    }
  }
}
